import { SwitchInputField } from "components/RenderInput"
import { Col, ListGroupItem, Row } from "reactstrap"
import { Field } from "redux-form"
import { vendors as VENDORS } from "config"

export const mapApiResponseToForm = (
  apiResponse = {},
  forms = [],
  websiteBranding
) => ({
  design: {
    primaryMenuColor: apiResponse?.menu_bg_color,
    secondaryTextColor: apiResponse?.menu_font_color,
    font: apiResponse?.menu_font_family,
    bgImage: { editedImage: apiResponse?.bg_image_url },
    brandImage: { editedImage: apiResponse?.logo },
    thumbnailImage: { editedImage: apiResponse?.event_thumbnail_url },
  },
  features: { menu: apiResponse?.menu },
  socialProfile: { formFields: forms },
  websiteBranding: {
    ...websiteBranding,
    banner_url: { editedImage: websiteBranding?.banner_url },
    logo_url: { editedImage: websiteBranding?.logo_url },
  },
})

export const required = value => (value ? undefined : "Required")

export const mapFormToApi = (formValues = {}) => ({
  menu_bg_color: formValues?.design?.primaryMenuColor,
  menu_font_color: formValues?.design?.secondaryTextColor,
  menu_font_family: formValues?.design?.font,
  bg_image_url: formValues?.design?.bgImage?.editedImage,
  logo: formValues?.design?.brandImage?.editedImage,
  event_thumbnail_url: formValues?.design?.thumbnailImage?.editedImage,
  menu: formValues?.features?.menu,
})

export const renderFeatures = ({
  fields,
  handleEditIcon,
  handleStatusChange,
}) => {
  return fields?.map((feature, index) => {
    const menuValues = fields.get(index)
    return (
      <ListGroupItem
        key={index}
        style={{
          borderRadius: "5px",
          border: "1px solid #ced4da",
        }}
        className="my-1"
      >
        <Row className="align-items-center">
          <Col xs="auto">
            <img src={menuValues?.icon?.url || ""} width="30px" height="auto" />
            <span
              style={{ color: "#485ec4", cursor: "pointer" }}
              onClick={() => {
                handleEditIcon(menuValues, feature)
              }}
            >
              <u>Edit</u>
            </span>
          </Col>
          <Col>
            <p>{menuValues?.label}</p>
          </Col>
          <Col xs="auto">
            <Field
              name={`${feature}.status`}
              component={SwitchInputField}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#2ECC71"
              offColor="#E74C3C"
              height={20}
              width={40}
              handleDiameter={18}
              onChange={(event, newValue, prevValue, name) => {
                if (newValue === false) {
                  handleStatusChange(name)
                }
              }}
            />
          </Col>
        </Row>
      </ListGroupItem>
    )
  })
}

export const SOCIAL_FORM_FIELDS = [
  { name: "display_name", label: "Display Name (how your name will appear to other users)", required: false, vendors: [] },
  { name: "display_email", label: "Display Email (how your email will appear to other users)", required: false, vendors: [] },
  { name: "title", label: "Title/Profession", required: false, vendors: [] },
  { name: "company", label: "Company", required: false, vendors: [] },
  { name: "phone", label: "Phone", required: false, vendors: [] },
  { name: "gender", label: "Preferred Pronoun(s)", required: false, vendors: [] },
  { name: "birthday", label: "Birthday", required: false, vendors: [] },
  { name: "birthdate", label: "Birth Date", required: false, vendors: [] },
  { name: "interests", label: "Interests", required: false, vendors: [] },
  { name: "bio", label: "Bio", required: false, vendors: [] },
  { name: "insta_link", label: "Instagram link", required: false, vendors: [] },
  { name: "tiktok_link", label: "Tiktok link", required: false, vendors: [] },
  {
    name: "linkedin_link",
    label: "Linkedin link",
    required: false,
    vendors: [],
  },
  { name: "yt_link", label: "Youtube link", required: false, vendors: [] },
  {
    name: "pinterest_link",
    label: "Pinterest link",
    required: false,
    vendors: [],
  },
  { name: "tw_link", label: "X (Twitter) link", required: false, vendors: [] },
  { name: "fb_link", label: "Facebook link", required: false, vendors: [] },
  {
    name: "languages",
    label: "Language(s)",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "date_of_birth",
    label: "DOB",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.TPI_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
    ],
  },
  {
    name: "occupation",
    label: "Sport/Occupation",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "occupation",
    label: "Occupation",
    required: false,
    vendors: [VENDORS.TPI_CLIENT_ID],
  },
  {
    name: "company_name",
    label: "Company Name",
    required: false,
    vendors: [VENDORS.TROTTA_CLIENT_ID],
  },
  {
    name: "country",
    label: "Country / Time zone",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "address",
    label: "Address",
    required: false,
    vendors: [
      VENDORS.TPI_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IMAC_CLIENT_ID,
      VENDORS.WESTERN_EDGE_CLIENT_ID,
    ],
  },
  {
    name: "address",
    label: "Street Address",
    required: false,
    vendors: [VENDORS.TROTTA_CLIENT_ID],
  },
  {
    name: "city",
    label: "City",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IMAC_CLIENT_ID,
      VENDORS.TROTTA_CLIENT_ID,
      VENDORS.IFO_CLIENT_ID,
    ],
  },
  {
    name: "state",
    label: "State",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IMAC_CLIENT_ID,
      VENDORS.TROTTA_CLIENT_ID,
      VENDORS.IFO_CLIENT_ID,
    ],
  },
  {
    name: "location",
    label: "Location / Travels from",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "zip_code",
    label: "Zip Code",
    required: false,
    vendors: [VENDORS.TROTTA_CLIENT_ID],
  },
  {
    name: "zip_code",
    label: "Postal Code",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "business_name",
    label: "Name of Business",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "business_name",
    label: "Name of Business/Association",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID, VENDORS.G2_CLIENT_ID],
  },
  {
    name: "business_type",
    label: "Type of Business/Association Industry",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "business_address",
    label: "Business Address (Street, City, Zip Code)",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "business_address",
    label: "Business/Association Address (Street, City, Zip Code)",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID, VENDORS.G2_CLIENT_ID],
  },
  {
    name: "social_media_followers_number",
    label: "Number of Social Media Followers",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "business_website",
    label: "Website",
    required: false,
    vendors: [
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IFO_CLIENT_ID,
    ],
  },
  {
    name: "social_media",
    label: "Social Media @",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID, VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "college_name",
    label: "Name of College (if applicable)",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "team_name",
    label: "Team Name",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "age",
    label: "Age Level",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "coach_first_name",
    label: "Coach's First Name",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "have_scheduled_appointment_before",
    label: "Have you scheduled an appointment before? (yes/no)",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "have_referral_from_doctor",
    label: "Do you have a referral from a doctor? (yes/no)",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "referral_doctor_name",
    label: "If you have a referral, please enter your doctor's name",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "how_did_you_hear_about_us",
    label:
      "How did you hear about us? (Doctor/Family/Friend/Google/Social Media/TV/Newspaper/Other)",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "receive_newsletter",
    label: "Would you like to receive our newsletter? (yes/no)",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "receive_horseman_corral",
    label: "Would you like to receive the Horseman's Corral? (yes/no)",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "aqha_number",
    label: "Enter your AQHA#",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "family_members",
    label:
      "Add Family Members (First Name, Last Name, Email, AQHA#, Date of Birth (MM/DD/YY))",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "years_experience",
    label: "Years Experience",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "area_of_expertise",
    label: "Areas of Expertise",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "certifications",
    label: "Certifications",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "fees",
    label: "Fees",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "offered_program",
    label: "Program Offered",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "partial_client_list",
    label: "Partial client list",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "ideal_time_to_meet",
    label: "Ideal time to meet",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "personal_goal_for_joining_a_forum",
    label: "Personal goal for joining a forum",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "how_long_have_you_been_a_facilitator",
    label: "How long have you been a facilitator?",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "previous_forum_experience",
    label: "Previous forum experience",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "currently_in_a_forum",
    label: "Are you currently in a forum?",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "interested_in_being_a_moderator",
    label: "Would you be interested in being a moderator?",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "forum_placement_preference",
    label: "Forum placement preference",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
]
